
export { MARKETING_BANNER_SLIDE_INTERVAL } from "/home/runner/work/capsicum/capsicum/libs/features/feeds/shared/src/models/marketing-banner.ts"
export { useMarketingBannerCarousel } from "/home/runner/work/capsicum/capsicum/libs/features/feeds/shared/src/hooks/useMarketingBannersCarousel.ts"